module.exports = __webpack_public_path__ + "static/media/credit_mastercard_class.a61d1a7f.svg";